<template>
  <div>
    <div class="register-steps">
      <div :class="`register-progress step${step}`"></div>
      <ul class="register-steps-scale">
        <li>1</li>
        <li>2</li>
        <li>3</li>
      </ul>
    </div>
    <vue100vh :css="{ height: 'calc(100rvh - 200px)' }">
      <router-view class="register-steps-content" />
    </vue100vh>
  </div>
</template>

<script>
import vue100vh from 'vue-100vh'

export default {
  data() {
    return {
      step: this.$route.meta.step
    }
  },
  watch: {
    $route(to) {
      this.step = to.meta.step
    }
  },
  components: {
    vue100vh
  }
}
</script>

<style lang="scss">
.register-steps {
  position: relative;
  width: 210px;
  height: 18px;
  margin-top: 50px;
  border-radius: 9px;
  background: #000;
}

.register-progress {
  width: calc(100% / 3);
  height: 100%;
  border-radius: 9px;
  background-image: linear-gradient(90deg, #7dccaa 0%, #f1c63f 100%);
  transition: all 1s;

  &.step2 {
    width: calc(100% * 2 / 3);
    background-image: linear-gradient(90deg, #893fc5 0%, #ff8071 100%);
  }

  &.step3 {
    width: 100%;
    background-image: linear-gradient(90deg, #00d1eb 0%, #fe8b68 100%);
  }
}

.register-steps-scale {
  position: absolute;
  top: 0;
  right: 10px;
  bottom: 0;
  left: 10px;
  display: flex;
  padding-left: 0 !important;
  opacity: 0.6;
  color: #fff;
  font-size: 12px;
  list-style: none;

  li {
    width: calc(100% / 3);
    text-align: center;
  }
}
</style>
